<template>
    <div class="login-form">
        <form class="login-form" @submit.prevent="login">
            <div class="form-gorup mb-2">
                <b-btn variant="light border-dark" @click="loginWithGoogle">
                    <span>
                        <i class="fab fa-google"></i>
                    </span>
                    Login with Google
                </b-btn>
            </div>


            <div class="form-group mb-0">
                <label for="inputEmail" class="sr-only">Email Address %#$(</label>
                <input ref="email" type="email" id="email" class="form-control" :class="{'is-invalid': underValidation && !email}" placeholder="Email Address" v-model="email" autofocus>
                <!-- <div class="invalid-feedback">
                    Email Address is required
                </div> -->
            </div>

            <div class="form-group mb-0">
                <label for="inputPassword" class="sr-only">Password</label>
                <input ref="password" type="password" id="password" class="form-control" :class="{'is-invalid': underValidation && !password}" placeholder="Password" v-model="password">
                <!-- <div class="invalid-feedback">
                    Password is required
                </div> -->
            </div>

            <button class="btn btn-lg btn-primary btn-block mt-2" type="submit" :disabled="lockForm">
                <span v-if="lockForm">
                    <font-awesome-icon :icon="['fad', 'circle-notch']" spin />
                </span>
                <span v-else>
                    <font-awesome-icon :icon="['fad', 'sign-in']" fixed-width /> Log In
                </span>
            </button>
            <a href="javascript:void(0);" v-b-modal.forgot_password>Forgot Password?</a>
        </form>
        <b-modal id="forgot_password" title="Forgot Password?" header-bg-variant="primary" header-class="text-white">
            <b-input v-model="forgot_password_email" type="email" placeholder="Email Address" :disabled="lockForm" />
            <template #modal-footer>
                <b-btn variant="secondary" @click="$bvModal.hide('forgot_password')" :disabled="lockForm">Close</b-btn>
                <b-btn variant="primary" @click="sendResetPasswordEmail" :disabled="lockForm">Send Reset Password Email</b-btn>
            </template>
        </b-modal>
    </div>
</template>

<style lang="scss" scoped>
@import "@/assets/scss/_colors.scss";

.fa-google {
    background: conic-gradient(from -45deg, #ea4335 110deg, #4285f4 90deg 180deg, #34a853 180deg 270deg, #fbbc05 270deg) 73% 55%/150% 150% no-repeat;
    -webkit-background-clip: text;
    background-clip: text;
    color: transparent;
    -webkit-text-fill-color: transparent;
}

.login-form .checkbox {
    font-weight: 400;
}
.login-form .form-control {
    position: relative;
    box-sizing: border-box;
    height: auto;
    padding: 10px;
    font-size: 16px;
}
.login-form .form-control:focus {
    z-index: 2;
}
.login-form input[type="email"] {
    margin-bottom: -1px;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0;
}
.login-form input[type="password"] {
    border-top-left-radius: 0;
    border-top-right-radius: 0;
}
</style>

<script>
export default {
    name: 'login-form',
    data: () => ({
        email: null,
        password: null,

        forgot_password_email: null,

        underValidation: false,
        lockForm: false
    }),
    computed: {
        redirectUrl() {
            var authRedirect = null;
            var queryRedirect = '/';

            if (this.$auth.redirect()) {
                authRedirect = this.$auth.redirect()
            }

            if (this.$route.query && this.$route.query.redirect) {
                queryRedirect = this.$route.query.redirect
            }

            return authRedirect ? authRedirect.from.fullPath : queryRedirect
        }
    },
    created() {

    },
    methods: {
        sendResetPasswordEmail() {
            this.underValidation = true;
            this.lockForm = true;
            if (!this.forgot_password_email) {
                this.$swal({
                    toast: true,
                    html: 'Please enter an email address',
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 5000
                })
                return false
            }

            this.$http.post('/auth/sendResetPassword', {
                email: this.forgot_password_email
            }).then((response) => {
                this.$swal({
                    toast: true,
                    html: 'You will receive a password reset e-mail, if an account exists with this e-mail address.',
                    type: 'success',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 5000
                })
            }).catch((error) => {
                this.$swal({
                    toast: true,
                    html: error.response.data.message,
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 5000
                })
            }).finally(() => {
                this.$bvModal.hide('forgot_password');
                this.underValidation = false;
                this.lockForm = false;
            });
        },
        loginWithGoogle() {
            if (this.$route.query && this.$route.query.redirect) {
                this.$store.commit('setAuthRedirect', this.$route.query.redirect);
            }

            let url = `${process.env.VUE_APP_API_URL}/api/auth/login/google`;
            window.location = url;
            this.$store.commit('setLoginRedirect', this.redirectUrl);
        },
        login () {
            if (!this.validatingLogin()) { return false }

            this.lockForm = true

            // console.log("AuthRedirect:", authRedirect);
            // console.log(queryRedirect);

            this.$auth.login({
                rememberMe: true,
                fetchUser: true,
                params: {
                    username: this.email,
                    password: this.password
                },
                redirect: {
                    path: this.redirectUrl
                },
                success: (response) => {
                    this.underValidation = false

                    // var queryRedirect = this.$route.query.redirect
                    //
                    // // routes back to page you routed to login page from
                    // if (authRedirect && !queryRedirect) {
                    //     this.$router.push({
                    //         name: authRedirect.from.name
                    //     })
                    // } else if (queryRedirect && !authRedirect) {
                    //     this.$router.push({
                    //         path: queryRedirect
                    //     })
                    // } else if (!queryRedirect && !authRedirect) {
                    //     this.$router.push({
                    //         name: 'home'
                    //     })
                    // }
                },
                error: (error) => {
                    this.underValidation = false;
                    this.lockForm = false;

                    // Handle known error
                    if (error.response && error.response.data.error) {
                        let errMessage = "Could not login. Something went wrong.";
                        if (error.response.data.error === 'login_error') {
                            errMessage = 'Could not login with the provided username and password. Please try again.';
                        } else if (errMessage === 'sw_employee') {
                            errMessage = 'Studies Weekly employees must sign in via Google.';
                        }
                        this.$swal({
                            toast: true,
                            html: errMessage,
                            type: 'error',
                            position: 'top-end',
                            showConfirmButton: false,
                            timer: 5000
                        });
                        return;
                    }
                    console.log(error.response);
                    this.$swal({
                        toast: true,
                        html: 'Something went wrong: ' + error.response.data.message,
                        type: 'error',
                        position: 'top-end',
                        showConfirmButton: false,
                        timer: 5000
                    })

                }
            })
        },
        validatingLogin () {
            this.underValidation = true

            var valid = true


            if (!this.email) {
                valid = false
                this.$refs.email.focus()
            }

            else if (!this.password) {
                valid = false
                this.$refs.password.focus()
            }

            if (!valid) {
                let message = null

                if (!this.email && !this.password) {
                    message = "Please enter an email address and password"
                } else if (!this.email && this.password) {
                    message = "Please enter an email address"
                } else if (this.email && !this.password) {
                    message = "Please enter a password"
                }

                this.$swal({
                    toast: true,
                    html: message,
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 5000
                })
            }

            let swEmployeeLogin = (process.env.VUE_APP_ENV !== 'local' && process.env.VUE_APP_ENV !== 'testing' && this.email.includes('@studiesweekly.com'));
            if (swEmployeeLogin) {
                valid = false;
                this.$refs.email.focus();
                this.$swal({
                    toast: true,
                    html: 'Studies Weekly accounts must login with Google.',
                    type: 'error',
                    position: 'top-end',
                    showConfirmButton: false,
                    timer: 5000
                })
            }

            return valid
        },
    }
}
</script>
